// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-text-content {
  display: flex;
  align-items: center;
}

.button-icon {
  display: flex;
  padding-right: 8px;
}`, "",{"version":3,"sources":["webpack://./projects/mydocma/dynamic-form/src/lib/fields/button/button-field/button-field.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/projects/mydocma/dynamic-form/src/lib/fields/button/button-field/button-field.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,kBAAA;ACCJ","sourcesContent":[".button-text-content {\r\n    display: flex;\r\n    align-items: center\r\n}\r\n\r\n.button-icon {\r\n    display: flex;\r\n    padding-right: 8px;\r\n}\r\n",".button-text-content {\n  display: flex;\n  align-items: center;\n}\n\n.button-icon {\n  display: flex;\n  padding-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
